import apiClient from './client'

export interface ProfileUpdateData {
  first_name?: string
  last_name?: string
  email?: string
  telefono?: string
}

export interface ProfileUpdateResponse {
  success: boolean
  message: string
  user?: {
    id: number
    username: string
    email: string
    first_name: string
    last_name: string
    is_staff: boolean
    is_superuser: boolean
    is_active: boolean
    groups: string[]
    telefono: string | null
    password_changed_once: boolean
    date_joined: string
    last_login: string | null
  }
}

export interface ChangePasswordData {
  old_password: string
  new_password1: string
  new_password2: string
}

export interface ChangePasswordResponse {
  success: boolean
  message: string
  errors?: Record<string, string>
}

export interface ForceChangePasswordData {
  new_password1: string
  new_password2: string
}

export interface PasswordResetRequestData {
  email: string
}

export interface PasswordResetConfirmData {
  uid: string
  token: string
  new_password1: string
  new_password2: string
}

export const authApi = {
  /**
   * Update user profile
   */
  updateProfile: async (data: ProfileUpdateData): Promise<ProfileUpdateResponse> => {
    const response = await apiClient.patch('/auth/profile/', data)
    return response.data
  },

  /**
   * Change user password
   */
  changePassword: async (data: ChangePasswordData): Promise<ChangePasswordResponse> => {
    const response = await apiClient.post('/auth/change-password/', data)
    return response.data
  },

  /**
   * Cambiar contraseña sin requerir la contraseña actual (primer inicio de sesión)
   */
  forceChangePassword: async (data: ForceChangePasswordData): Promise<ChangePasswordResponse> => {
    const response = await apiClient.post('/auth/force-change-password/', data)
    return response.data
  },

  /**
   * Solicita un enlace de recuperación de contraseña (usuario no autenticado).
   * Siempre responde con un mensaje genérico para no revelar si el email existe.
   */
  requestPasswordReset: async (data: PasswordResetRequestData): Promise<ChangePasswordResponse> => {
    const response = await apiClient.post('/auth/password-reset/request/', data)
    return response.data
  },

  /**
   * Valida un token de recuperación sin cambiar la contraseña.
   */
  validatePasswordReset: async (data: { uid: string; token: string }): Promise<ChangePasswordResponse> => {
    const response = await apiClient.post('/auth/password-reset/validate/', data)
    return response.data
  },

  /**
   * Confirma el cambio de contraseña usando el token de recuperación.
   */
  confirmPasswordReset: async (data: PasswordResetConfirmData): Promise<ChangePasswordResponse> => {
    const response = await apiClient.post('/auth/password-reset/confirm/', data)
    return response.data
  },
}
